// @ts-expect-error moduleResolution:nodenext issue 54523
import { html, LitElement, nothing } from 'lit';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement, property, state } from 'lit/decorators.js';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import LightElement from './light-element.js';
import { IProduct } from '../../../../wishlistsrc/src/models/IProduct.model';
import SelectorFilter from "../../typescript/modules/selector-filter.js";
import ProductVariants from "../../typescript/modules/product-variants";
import ProductVariantsGallery from "../../typescript/modules/product-variants-gallery.js";
import AlgoliaTracking from "../../typescript/modules/algolia-tracking";
import Helpers from '../../typescript/modules/helpers.js';
import Logger from '../../typescript/modules/logger.js';

declare var Splide: any;

let _carouselKeyboardScrollPrevented = false;

type PendingCarouselAction = { direction: '<' | '>' } | { variantIndex: number };

@customElement('product-card')
export default class ProductCard extends LightElement {

	private static readonly SCROLL_PRE_BUILD_DEBOUNCE_MS = 400;
	private static cardsPendingScrollPreBuild = new Set<ProductCard>();
	private static scrollPreBuildListenerRegistered = false;

	@property({ type: String })
	type: string; // outline, blog, wishlist

	@property({ type: Boolean })
	standalone: boolean; // outline, blog, wishlist

	@property({ type: String })
	info: string;

	@property({ type: Boolean })
	showAddButton: boolean;

	@property({ type: String })
	addButtonLoggerSource: string;

	@property({ type: Boolean })
	hideVariants: boolean;

	@property({ type: Boolean })
	hideSiblings: boolean;

	// Using the default Boolean type for this did not work with isLoading="false", so using a custom converter
	@property({
		converter: {
			fromAttribute: (value, type) => {
				if (value === "true") {
					return true
				}
				return false;
			},
			toAttribute: (value, type) => {
				return value + "";
			}
		}
	})
	isLoading: boolean;

	@property({ type: Boolean })
	showAddButtonOnBasket: boolean;

	@property({ type: String })
	addButtonOnBasketTest: string;

	@property({ type: Function })
	addButtonOnBasketClick: () => void;

	@property({ type: Function })
	productLinkOnClick: () => void;

	@property({ type: String })
	test = "product-block";

	@property({ type: String })
	testProductDisplayName: string;

	@property({ type: String })
	testProductDeliveryEstimate = "product-delivery-estimate";

	@property({ type: Boolean })
	eagerLoadImages = false;

	@state()
	private _carouselActive: boolean = false;

	@state()
	private _carouselClicked: boolean = false;

	@state()
	private _carouselImagesEager: boolean = false;

	@state()
	isComparing: boolean;

	@state()
	comparingMode: boolean

	@property({
		converter: {
			fromAttribute: (value) => {
				let result = value;
				try {
					if(typeof value === 'string') {
						result = JSON.parse(value) as JSON;
					} else if (typeof value === 'object') {
						result = value;
					} else {
						result = null;
					}
				} catch (x) {
					result = value;
					console.error(`Could not JSON.parse value ${value}`);
				}
				return result;
			},
			toAttribute: (value) => {
				try {
					return JSON.stringify(value);
				} catch (x) {
					console.error(`Could not JSON.stringify value ${value}`);
					return '';
				}
			}
		}

	})
	product: IProduct;
	debouncedGetSwatchesOnOneLine: { (): void; cancel(): void; };

	@state()
	private _numberHiddenSwatches: number;

	@state()
	private _allowMoreTextToBreakOnToNewLine: boolean;

	@state()
	private _isCarouselMode: boolean = false;


	@state()
	private _carouselInitialised: boolean = false;

	private _pendingCarouselAction: PendingCarouselAction | null = null;

	private debouncedUpdateCarouselMode: () => void;

	private instances = {
		slideshow: null as any
	};

	connectedCallback() {
		super.connectedCallback();
		if (this.querySelector('.c-load-content-placeholder__item')) {
			this.querySelector('.c-load-content-placeholder__item').remove();
		}
		this.checkIfShouldEagerLoadImages();
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		if (this.debouncedGetSwatchesOnOneLine) {
			window.removeEventListener('resize', this.debouncedGetSwatchesOnOneLine);
		}
		if (this.debouncedUpdateCarouselMode) {
			window.removeEventListener('resize', this.debouncedUpdateCarouselMode);
		}
		document.removeEventListener('productComparisonMode', this.handleComparisonModeChange);
		document.removeEventListener('productComparisonUpdated', this.handleComparisonUpdate);
		ProductCard.cardsPendingScrollPreBuild.delete(this);
	}

	firstUpdated() {
		this._isCarouselMode = this.isCarouselMode();
		this.initProductVariantBehaviour();

		setTimeout(() => {
			this.getSwatchesOnOneLine();
		}, 150);

		const debouncedGetSwatchesOnOneLine = Helpers.debounce(()=>this.getSwatchesOnOneLine(), 150);
		this.debouncedGetSwatchesOnOneLine = debouncedGetSwatchesOnOneLine;
		window.addEventListener('resize', debouncedGetSwatchesOnOneLine);

		this.checkIsInComparison();
		this.checkIsComparingMode();
		this.listenForComparisonModeChanges();
		this.listenForComparisonUpdates();

		const debouncedUpdateCarouselMode = Helpers.debounce(() => {
			this._isCarouselMode = this.isCarouselMode();
		}, 150);
		this.debouncedUpdateCarouselMode = debouncedUpdateCarouselMode;
		window.addEventListener('resize', debouncedUpdateCarouselMode);

		this.addEventListener('pointerenter', () => this.initialiseCarouselOnFirstInteraction());

		if (this.isMobileOrHasTouch()) {
			ProductCard.cardsPendingScrollPreBuild.add(this);
			ProductCard.ensureScrollPreBuildListenerRegistered();
		}
	}

	updated(changedProperties: Map<string, any>) {
		super.updated(changedProperties);

		if (changedProperties.has('_isCarouselMode') && !this._isCarouselMode) {
			this.destroySlideshow();
			this._carouselInitialised = false;
			this._pendingCarouselAction = null;
		}

		if (changedProperties.has('_isCarouselMode') || changedProperties.has('product')) {
			this.initProductVariantBehaviour();
		}

		if (changedProperties.has('product')) {
			this.destroySlideshow();
			this._carouselInitialised = false;
			this._pendingCarouselAction = null;
		}
	}

	private async initialiseCarouselOnFirstInteraction(pendingAction?: PendingCarouselAction) {
		if (pendingAction) {
			this._pendingCarouselAction = pendingAction;
		}

		ProductCard.cardsPendingScrollPreBuild.delete(this);

		if (this._carouselInitialised || this.instances.slideshow) {
			return;
		}

		this._carouselInitialised = true;
		await this.updateComplete;
		this.waitForCarouselImagesToLoad();
	}

	private static checkCardsForScrollPreBuild() {
		const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

		for (const card of Array.from(ProductCard.cardsPendingScrollPreBuild)) {
			if (!card.isConnected) {
				ProductCard.cardsPendingScrollPreBuild.delete(card);
				continue;
			}

			const rect = card.getBoundingClientRect();
			const isInViewport = rect.bottom > 0 && rect.top < viewportHeight;
			if (isInViewport) {
				ProductCard.cardsPendingScrollPreBuild.delete(card);
				card.initialiseCarouselOnFirstInteraction();
			}
		}
	}

	private static debouncedScrollPreBuildCheck = Helpers.debounce(
		() => ProductCard.checkCardsForScrollPreBuild(),
		ProductCard.SCROLL_PRE_BUILD_DEBOUNCE_MS
	);

	private static ensureScrollPreBuildListenerRegistered() {
		if (ProductCard.scrollPreBuildListenerRegistered) {
			return;
		}
		ProductCard.scrollPreBuildListenerRegistered = true;
		window.addEventListener('scroll', () => ProductCard.debouncedScrollPreBuildCheck(), { passive: true });
	}

	private handleStaticArrowClick(event: Event, direction: '<' | '>') {
		event.preventDefault();
		event.stopPropagation();

		this._carouselClicked = true;
		this._carouselActive = true;

		if (this.instances.slideshow) {
			this.instances.slideshow.go(direction);
			return;
		}

		this.initialiseCarouselOnFirstInteraction({ direction });
	}

	private destroySlideshow() {
		if (this.instances.slideshow) {
			this.instances.slideshow.destroy(true);
			this.instances.slideshow = null;
			const leftButton = this.querySelector('.c-carousel__button--left') as HTMLButtonElement;
			const rightButton = this.querySelector('.c-carousel__button--right') as HTMLButtonElement;
			Helpers.removeElement(leftButton);
			Helpers.removeElement(rightButton);
		}
	}

	private initProductVariantBehaviour() {
		const productVariantElements = SelectorFilter.excludeByClass(this.querySelectorAll('.js-product-variant'), 'js-product-variant-done');
		if (productVariantElements.length) {
			if (this._isCarouselMode) {
				new ProductVariantsGallery(productVariantElements);
			} else {
				new ProductVariants(productVariantElements);
			}
		}
	}

	private isCarouselMode(): boolean {
		return Helpers.activeSite() !== 'TapWarehouse' || window.innerWidth >= 980;
	}

	private getSwatchesOnOneLine() {
		const container = this.querySelector('.c-product__variants') as HTMLElement;
		if (!container) {
			return;
		}

		const containerWidth = container.offsetWidth - 6; // 6 is the outside padding
		const swatches = this.querySelectorAll('.c-product__variants__item--swatch') as NodeListOf<HTMLElement>;

		if (!swatches.length) {
			return;
		}

		this.shouldAllowMoreTextToBreakOnToNewLine(containerWidth);

		const swatchWidth = swatches[0].offsetWidth || 34;
		const moreText = this.querySelector('.js-variant-options-text') as HTMLElement;
		const moreTextWidth = moreText && !this._allowMoreTextToBreakOnToNewLine ? moreText.offsetWidth : 0;

		// Work out how many swatches fit, without any DOM writes
		let totalWidth = moreTextWidth;
		let numberHiddenSwatches = 0;
		const swatchOverflows: boolean[] = [];
		for (let i = 0; i < swatches.length; i++) {
			totalWidth += swatchWidth;
			const hide = totalWidth > containerWidth;
			swatchOverflows.push(hide);
			if (hide) numberHiddenSwatches++;
		}

		// Find the last visible swatch — it will also be hidden, replaced by the +N counter
		let lastVisibleIndex = -1;
		if (numberHiddenSwatches > 0) {
			for (let i = swatches.length - 1; i >= 0; i--) {
				if (!swatchOverflows[i]) {
					lastVisibleIndex = i;
					break;
				}
			}
			if (lastVisibleIndex !== -1) {
				numberHiddenSwatches++;
			}
		}

		// Defer all writes to the next animation frame
		// This prevents invalidating layout between cards that are still in the read phase.
		requestAnimationFrame(() => {
			for (let i = 0; i < swatches.length; i++) {
				swatches[i].style.display = (swatchOverflows[i] || i === lastVisibleIndex) ? 'none' : '';
			}
			this._numberHiddenSwatches = numberHiddenSwatches;
		});
	}

	private checkIfShouldEagerLoadImages() {
		const productCardList = document.querySelector('.js-product-results-list');
		if (!productCardList || productCardList.querySelector('product-card') !== this) {
			return;
		}

		if (this.isInOrNearViewport()) {
			this.eagerLoadImages = true;
			return;
		}

		if ('IntersectionObserver' in window) {
			const observer = new IntersectionObserver((entries) => {
				for (const entry of entries) {
					if (entry.target === this && (entry.isIntersecting || entry.intersectionRatio > 0)) {
						this.eagerLoadImages = true;
						observer.disconnect();
						break;
					}
				}
			}, {
				root: null,
				rootMargin: '300px 0px',
				threshold: 0
			});

			observer.observe(this);
		}
	}

	private isInOrNearViewport() {
		const rect = this.getBoundingClientRect();
		const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
		return rect.top <= viewportHeight + 300 && rect.bottom >= -300;
	}

	private shouldAllowMoreTextToBreakOnToNewLine(containerWidth) {
		this._allowMoreTextToBreakOnToNewLine = this.closest('.c-carousel') !== null;
		if (this._allowMoreTextToBreakOnToNewLine) {
			return true;
		}
		if (!this._allowMoreTextToBreakOnToNewLine && containerWidth < 200) {
			this._allowMoreTextToBreakOnToNewLine = true;
			return true;
		}
		this._allowMoreTextToBreakOnToNewLine = false;
		return false;
	}

	private algoliaSource() {
		const possibleAlgoliaSourceElement = this.closest('[data-algolia-source]');
		if (possibleAlgoliaSourceElement) {
			return possibleAlgoliaSourceElement.getAttribute('data-algolia-source');
		}
		return 'Search Results';
	}

	private algoliaQueryIDOverride() {
		const possibleAlgoliaQueryIDElement = this.closest('[data-algolia-query-id]');
		if (possibleAlgoliaQueryIDElement) {
			return possibleAlgoliaQueryIDElement.getAttribute('data-algolia-query-id');
		}
		return undefined;
	}

	private getProductURL() {

		if (AlgoliaTracking.isSearchPage()) {
			return AlgoliaTracking.addAlgoliaQueryToURL(this.product.Url, this.product.Guid, this.algoliaSource());
		}

		const algoliaQueryIDOverride = this.algoliaQueryIDOverride();
		if (algoliaQueryIDOverride) {
			return AlgoliaTracking.addAlgoliaQueryToURL(this.product.Url, this.product.Guid, this.algoliaSource(), algoliaQueryIDOverride);
		}

		return this.product.Url;

	}

	private async waitForCarouselImagesToLoad() {
		if (!this.isConnected || !this._isCarouselMode) return;
		const container = this.querySelector('[data-product-card-slideshow-container]');
		if (!container) {
			setTimeout(() => this.initSlider(), 100);
			return;
		}

		if (container.querySelectorAll('img').length === 0) {
			setTimeout(() => this.initSlider(), 100);
			return;
		}

		this._carouselImagesEager = true;
		await this.updateComplete;

		const images = container.querySelectorAll('img');

		let loadedCount = 0;
		let hasError = false;

		const checkAllLoaded = () => {
			if (loadedCount === images.length || hasError) {
				this.initSlider();
			}
		};

		images.forEach(img => {
			if (img.complete) {
				loadedCount++;
				checkAllLoaded();
			} else {
				img.addEventListener('load', () => {
					loadedCount++;
					checkAllLoaded();
				}, { once: true });

				img.addEventListener('error', () => {
					hasError = true;
					checkAllLoaded();
				}, { once: true });
			}
		});

		setTimeout(() => {
			if (loadedCount < images.length && !hasError) {
				this.initSlider();
			}
		}, 3000);
	}

	private initSlider() {
		try {
			if (typeof Splide === 'undefined') {
				setTimeout(() => this.initSlider(), 100);
				return;
			}
			if (this.instances.slideshow) {
				this.destroySlideshow();
			}
			const container = this.querySelector('[data-product-card-slideshow-container]');
			if (!container) {
				return;
			}
			const slideshowItems = container.querySelectorAll('[data-product-card-slideshow-item]');

			if (slideshowItems.length > 1) {
				this.instances.slideshow = new Splide(container, {
					type: 'loop',
					perPage: 1,
					perMove: 1,
					start: 0,
					speed: 600,
					interval: 5000,
					heightRatio: 1,
					pagination: false,
					rewind: true,
					arrows: false,
					keyboard: 'focused',
					classes: {
						prev: 'c-carousel__button c-carousel__button--left js-carousel-button-left',
						next: 'c-carousel__button c-carousel__button--right js-carousel-button-right',
						pagination: 'c-carousel__pagination',
						page: 'c-carousel__pagination-page'
					}
				});

				this.instances.slideshow.on('mounted', () => {
					this.applyPendingCarouselAction();
					container.setAttribute('data-test-active-slide-index', String(this.instances.slideshow.index));
				});

				this.instances.slideshow.on('moved', (newIndex: number) => {
					container.setAttribute('data-test-active-slide-index', String(newIndex));
				});

				let hasMounted = false;
				this.instances.slideshow.on('mounted', () => {
					setTimeout(() => {
						if (container) {
							container.removeAttribute('tabindex');
							const slides = container.querySelectorAll('.splide__slide');
							for (var i = 0; i < slides.length; i++) { slides[i].removeAttribute('tabindex'); }
						}
					}, 1000);

					if (!hasMounted) {
						hasMounted = true;

						this.addProductCarouselArrows(container);
						this.preventFirefoxImageDrag(container);
						this.preventParentCarouselScroll(container);
						this.preventParentCarouselKeyboardScroll(container);

						// When inside a parent carousel the container width may not be stable at mount time, causing Splide to calculate incorrect slide positions. Use ResizeObserver to refresh once the container reaches its final stable width.
						const isInParentCarousel = this.closest('.c-carousel') !== null;
						if (isInParentCarousel) {
							let stableWidth = 0;
							const resizeObserver = new ResizeObserver((entries) => {
								const width = entries[0].contentRect.width;
								if (width > 0 && width !== stableWidth) {
									stableWidth = width;
									if (this.instances.slideshow) {
										this.instances.slideshow.refresh();
										this.instances.slideshow.go(this.instances.slideshow.index);
									}
								}
							});
							resizeObserver.observe(container);
							setTimeout(() => {
								resizeObserver.disconnect();
								container.setAttribute('data-test-carousel-ready', 'true');
							}, 2000);
						} else {
							// Standalone cards: simple timeout refresh as before
							setTimeout(() => {
								if (this.instances.slideshow) {
									this.instances.slideshow.refresh();
									this.instances.slideshow.go(this.instances.slideshow.index);
								}
								container.setAttribute('data-test-carousel-ready', 'true');
							}, 1000);
						}
					}
				});

				this.instances.slideshow.mount();

				this.setupCarouselControls();

				if (Helpers.activeSite() !== 'TapWarehouse') {
					this.addCarouselSwipeHint();
				}
			} else {
				container.classList.add('c-carousel--single');
			}

		} catch (error) {
			console.error('Product card carousel error:', error);
			Logger.trackException(error as Error);
		}
	}

	private setupCarouselControls() {
		const carouselButtons = this.querySelectorAll('.c-carousel__button');
		const productCard = this.querySelector('.c-product');

		carouselButtons.forEach(button => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				this._carouselClicked = true;
				this._carouselActive = true;
			});
		});

		if (productCard) {
			productCard.addEventListener('mouseenter', () => {
				if (this._carouselClicked) {
					this._carouselActive = true;
				}
			});

			productCard.addEventListener('mouseleave', () => {
				if (!this._carouselClicked) {
					this._carouselActive = false;
				}
			});
		}
	}

	private isMobileOrHasTouch(): boolean {
		return window.innerWidth < 980 || Helpers.isTouch() || Helpers.isIOS();
	}

	private addCarouselSwipeHint() {
		if (!this.isMobileOrHasTouch()) return;

		let scrollCarouselParent = this.closest('.js-product-results-list, .js-scroll-carousel');
		if (!scrollCarouselParent) {
			scrollCarouselParent = this.closest('.js-products-list');
		}
		if (!scrollCarouselParent) return;

		const isInATBOverlay = this.closest('[data-atb]') !== null;

		if (isInATBOverlay) {
			const firstElement = scrollCarouselParent.querySelector('[data-product-id]');
			if (!firstElement) return;

			const firstProductId = firstElement.getAttribute('data-product-id');
			const isFirstProduct = firstProductId === this.product.Name;
			if (!isFirstProduct) return;
		} else {
			const firstScrollCarousel = Array.from(document.querySelectorAll('.js-product-results-list, .js-scroll-carousel, .js-products-list'))
				.find(el => el.querySelector('product-card') !== null) ?? null;
			if (scrollCarouselParent !== firstScrollCarousel) return;

			const firstElement = firstScrollCarousel.querySelector('[data-product-id]');
			if (!firstElement) return;

			const firstProductId = firstElement.getAttribute('data-product-id');
			const isFirstProduct = firstProductId === this.product.Name;
			if (!isFirstProduct) return;
		}

		const container = this.querySelector('[data-product-card-slideshow-container]');
		if (container && !container.classList.contains('c-carousel--single')) {
			setTimeout(() => {
				this.triggerCarouselHint(container);
			}, 500);
		}
	}

	private triggerCarouselHint(container: Element) {
		if (!this.instances.slideshow) return;

		const splideList = container.querySelector('.splide__list') as HTMLElement;
		if (!splideList) return;

		// Disable drag during the hint
		this.instances.slideshow.options.drag = false;

		const computedStyle = window.getComputedStyle(splideList);
		const currentMatrix = computedStyle.transform;
		let currentTranslateX = 0;
		const currentMatrixValues = currentMatrix.match(/matrix\((.+)\)/);
		if (currentMatrixValues) {
			const values = currentMatrixValues[1].split(', ');
			currentTranslateX = parseFloat(values[4]);
		}

		const startTime = performance.now();
		const duration = 2000;
		const peekAmount = 30;

		const animate = (currentTime: number) => {
			const elapsed = currentTime - startTime;
			const progress = Math.min(elapsed / duration, 1);
			let peekTranslate = currentTranslateX;
			if (progress < 0.5) {
				peekTranslate = currentTranslateX - (peekAmount * (progress * 2));
			} else {
				peekTranslate = currentTranslateX - (peekAmount * (2 - progress * 2));
			}

			splideList.style.transform = `translateX(${peekTranslate}px)`;

			if (progress < 1) {
				requestAnimationFrame(animate);
			} else {
				splideList.style.transform = '';
				this.instances.slideshow.refresh();
				this.instances.slideshow.options.drag = true;
			}
		};

		requestAnimationFrame(animate);
	}

	private preventFirefoxImageDrag(container: Element) {
		const track = container.querySelector('.splide__track');
		if (!track) return;
		track.addEventListener('mousedown', (e: Event) => {
			if ((e.target as HTMLElement).tagName === 'IMG') {
				e.preventDefault();
			}
		});
	}

	private preventParentCarouselScroll(container: Element) {
		if (Helpers.isIOS()) return;

		const track = container.querySelector('.splide__track') as HTMLElement;
		if (!track) return;

		track.addEventListener('pointerdown', (e) => { e.stopPropagation(); });
		track.addEventListener('pointermove', (e) => { e.stopPropagation(); });
		track.addEventListener('pointerup', (e) => { e.stopPropagation(); });
		track.addEventListener('touchstart', (e) => { e.stopPropagation(); });
		track.addEventListener('touchmove', (e) => { e.stopPropagation(); });
		track.addEventListener('touchend', (e) => { e.stopPropagation(); });
	}

	private preventParentCarouselKeyboardScroll(container: Element) {
		const scrollCarousel = this.closest('.js-scroll-carousel');
		if (!scrollCarousel) return;
		if (_carouselKeyboardScrollPrevented) return;
		_carouselKeyboardScrollPrevented = true;

		document.addEventListener('keydown', (e: Event) => {
			const key = (e as KeyboardEvent).key;
			if (key !== 'ArrowLeft' && key !== 'ArrowRight') return;
			const target = e.target as Element;
			if (target && target.closest('.c-product__carousel')) {
				e.preventDefault();
			}
		}, true);
	}

	private addProductCarouselArrows(container: Element) {
		const arrowsHTML = `
			<button class="c-carousel__button c-carousel__button--left js-carousel-button-left" type="button" aria-label="Previous slide" data-test="product-card-carousel-previous">
				<svg viewBox="0 0 25.08 55.69" class="c-carousel__button__icon" fill="currentColor">
					<path d="M1.61,55.69a1.57,1.57,0,0,1-1-.36,1.62,1.62,0,0,1-.23-2.27L20.92,27.85.36,2.63a1.61,1.61,0,0,1,2.5-2L25.08,27.85,2.86,55.1A1.61,1.61,0,0,1,1.61,55.69Z"/>
				</svg>
			</button>
			<button class="c-carousel__button c-carousel__button--right js-carousel-button-right" type="button" aria-label="Next slide" data-test="product-card-carousel-next">
				<svg viewBox="0 0 25.08 55.69" class="c-carousel__button__icon" fill="currentColor">
					<path d="M1.61,55.69a1.57,1.57,0,0,1-1-.36,1.62,1.62,0,0,1-.23-2.27L20.92,27.85.36,2.63a1.61,1.61,0,0,1,2.5-2L25.08,27.85,2.86,55.1A1.61,1.61,0,0,1,1.61,55.69Z"/>
				</svg>
			</button>
		`;
		container.insertAdjacentHTML('afterbegin', arrowsHTML);

		const leftButton = container.querySelector('.c-carousel__button--left') as HTMLButtonElement;
		const rightButton = container.querySelector('.c-carousel__button--right') as HTMLButtonElement;

		leftButton.addEventListener('click', () => {
			this.instances.slideshow.go('<');
			container.setAttribute('data-test-active-slide-index', String(this.instances.slideshow.index));
		});
		rightButton.addEventListener('click', () => {
			this.instances.slideshow.go('>');
			container.setAttribute('data-test-active-slide-index', String(this.instances.slideshow.index));
		});
	}

	public navigateCarouselToVariant(productGuid: string) {
		if (!this.product.Gallery) {
			return;
		}

		const galleryIndex = this.product.Gallery.findIndex(item => item.ProductGuid === productGuid);
		if (galleryIndex === -1) {
			return;
		}

		if (!this.instances.slideshow) {
			this.initialiseCarouselOnFirstInteraction({ variantIndex: galleryIndex });
			return;
		}

		this.jumpToIndexInstantly(galleryIndex);

		const container = this.querySelector('[data-product-card-slideshow-container]');
		container?.setAttribute('data-test-active-slide-index', String(this.instances.slideshow.index));
	}

	private jumpToIndexInstantly(index: number) {
		const originalSpeed = this.instances.slideshow.options.speed;
		this.instances.slideshow.options.speed = 0;
		this.instances.slideshow.go(index);
		this.instances.slideshow.options.speed = originalSpeed;
	}

	// Applies an arrow-click or variant-hover interaction that arrived before the carousel had
	// finished initialising and then called once Splide has actually mounted.
	private applyPendingCarouselAction() {
		const action = this._pendingCarouselAction;
		if (!action) {
			return;
		}
		this._pendingCarouselAction = null;

		if ('direction' in action) {
			this.instances.slideshow.go(action.direction);
		} else {
			this.jumpToIndexInstantly(action.variantIndex);
		}
	}

	private addToComparison() {
		const updateProductComparisonEvent = Helpers.createCustomEventForDispatch('productComparisonProductUpdate', {
			productId: this.product.Name
		});
		document.dispatchEvent(updateProductComparisonEvent);
		setTimeout(() => {
			this.checkIsInComparison();
		}, 250);
	}

	private checkIsInComparison() {
		const comparisonKey = 'productComparisonIds';
		const comparisonIds = JSON.parse(localStorage.getItem(comparisonKey) || '[]');

		if (!this.product) {
			this.isComparing = false;
			return;
		}

		this.isComparing = comparisonIds.includes(this.product.Name);
	}

	private checkIsComparingMode() {
		const comparingMode = localStorage.getItem('comparingMode');
		if (comparingMode === 'true' && this.isInCategory()) {
			this.comparingMode = true;
		} else {
			this.comparingMode = false;
		}
	}

	private isInCategory(): boolean {
		return document.querySelector('.mRange') !== null && !document.querySelector('btu-calculator');  // Disable comparing mode if BTU calculator is present
	}

	private listenForComparisonModeChanges() {
		document.addEventListener('productComparisonMode', this.handleComparisonModeChange);
	}

	private handleComparisonModeChange = (event: CustomEvent) => {
		this.comparingMode = event.detail.mode === "true";
	}

	private listenForComparisonUpdates() {
		document.addEventListener('productComparisonUpdated', this.handleComparisonUpdate);
	}

	private handleComparisonUpdate = (event: CustomEvent) => {
		this.checkIsInComparison();
	}

	render() {

		if (!this.product) {
			return;
		}

		let showPreviews = (this.product.Previews && this.product.Previews.length || this.product.ShowVariantOptionsText) && !this.hideVariants;
		if (!this.product.HasVariants && this.hideSiblings) {
			showPreviews = false;
		}

		const productURL = this.getProductURL();
		const isCarouselMode = this._isCarouselMode;

		return html`
		<article id="product-${this.product.Name}"
		class="c-product js-product ${this.standalone ? 'c-product--constrain' : ''} ${this.type ? `c-product--${this.type}` : ''} ${this.showAddButton || this.showAddButtonOnBasket ? `c-product--with-dynamic-add` : ''} ${this.isLoading ? 'is-loading' : ''}"
		data-test="${this.test}"
		data-link="${productURL}"
		data-info="${this.info}"
		data-source="${this.product.Source || nothing}"
		data-relation-product="${this.product.RelationProduct || nothing}"
		data-test-product-id="${this.product.Name}"
		data-component="product-card.ts"
		data-product-id="${this.product.Name}"
		data-product-guid="${this.product.Guid}"
		data-product-name="${this.product.DisplayName}"
		data-product-price="${this.product.Price.Price}"
		data-product-review-score="${this.product.ReviewAverage}"
		data-product-rank="${this.product.Rank}"
		data-product-sale-rate-score="${this.product.SaleRateScore}"
		data-product-has-variants="${this.product.HasVariants || nothing}">
					<div class="c-product__inner" data-test-product-id="${this.product.Name}" data-test-sort-score="${this.product.SaleRateScore || nothing}">
						<div class="c-product__image-variants">
							${isCarouselMode && this.product.HasOverlays ?
							html`
								<div class="c-product__overlay c-product__overlay--desktop c-merch-overlay__group" data-test="merchandise-overlay">
									${this.product.Overlays.map((overlay) => {
											return html`
											<merch-overlay
												shortText="${overlay.ShortText}"
												backgroundColor="${overlay.Theme.BackgroundColor}"
												textColor="${overlay.Theme.TextColor}"
											></merch-overlay>
										`;
											})}
								</div>`
							: null}
							<a href="${productURL}" class="c-product__image js-product-link" @click="${this.productLinkOnClick}" data-test="primary-image" data-instant>
								${isCarouselMode ?
								html`
								${this.product.Gallery && this.product.Gallery.length > 0 ?
								html`
								${this._carouselInitialised ?
								html`
								<div class="c-product__carousel c-carousel c-carousel--faded-edges splide ${this._carouselActive ? 'c-carousel--active' : ''}" data-product-card-slideshow-container data-test="product-card-carousel" data-test-active="${this._carouselActive}">
									<div class="c-product__carousel__inner">
										<div class="c-carousel__inner splide__track">
											<ul class="c-carousel__list splide__list" data-product-card-slideshow>
											${this.product.Gallery.map((image, index) => html`
												<li class="c-carousel__item splide__slide" data-product-card-slideshow-item data-test="product-card-carousel-slide">
													<div class="c-image c-image--square">
														<picture>
															<source srcset="${image.Url}?height=412&width=412&mode=crop&scale=both&format=webp&quality=80" type="image/webp">
															<img src="${image.Url}?height=412&width=412&mode=crop&scale=both&quality=80" loading="${this._carouselImagesEager || (this.eagerLoadImages && index === 0) ? 'eager' : 'lazy'}" fetchpriority="${this.eagerLoadImages && index === 0 ? 'high' : nothing}" alt="${image.Alt}" width="412" height="412">
														</picture>
													</div>
												</li>
											`)}
											</ul>
										</div>
									</div>
								</div>
								`
								:
								html`
								<div class="c-product__carousel c-carousel c-carousel--faded-edges" data-test="product-card-carousel-static">
									<div class="c-image c-image--square">
										<picture>
											<source srcset="${this.product.Gallery[0].Url}?height=412&width=412&mode=crop&scale=both&format=webp&quality=80" type="image/webp">
											<img src="${this.product.Gallery[0].Url}?height=412&width=412&mode=crop&scale=both&quality=80" loading="${this.eagerLoadImages ? 'eager' : 'lazy'}" fetchpriority="${this.eagerLoadImages ? 'high' : nothing}" alt="${this.product.Gallery[0].Alt}" width="412" height="412">
										</picture>
									</div>
									${this.product.Gallery.length > 1 ?
									html`
									<button class="c-carousel__button c-carousel__button--left js-carousel-button-left" type="button" aria-label="Previous slide" data-test="product-card-carousel-previous" @click="${(event: Event) => this.handleStaticArrowClick(event, '<')}">
										<svg viewBox="0 0 25.08 55.69" class="c-carousel__button__icon" fill="currentColor">
											<path d="M1.61,55.69a1.57,1.57,0,0,1-1-.36,1.62,1.62,0,0,1-.23-2.27L20.92,27.85.36,2.63a1.61,1.61,0,0,1,2.5-2L25.08,27.85,2.86,55.1A1.61,1.61,0,0,1,1.61,55.69Z"/>
										</svg>
									</button>
									<button class="c-carousel__button c-carousel__button--right js-carousel-button-right" type="button" aria-label="Next slide" data-test="product-card-carousel-next" @click="${(event: Event) => this.handleStaticArrowClick(event, '>')}">
										<svg viewBox="0 0 25.08 55.69" class="c-carousel__button__icon" fill="currentColor">
											<path d="M1.61,55.69a1.57,1.57,0,0,1-1-.36,1.62,1.62,0,0,1-.23-2.27L20.92,27.85.36,2.63a1.61,1.61,0,0,1,2.5-2L25.08,27.85,2.86,55.1A1.61,1.61,0,0,1,1.61,55.69Z"/>
										</svg>
									</button>
									`
									: nothing}
								</div>
								`}
								`
								: nothing}
								` :
								html`
								<div class="c-image c-image--square js-image js-product-image ${this.product.HasHoverImage ? 'c-image--hover js-hover-image' : ''}">
									<picture>
										<source srcset="${this.product.ImageUrl}?height=412&width=412&mode=crop&scale=both&format=webp&quality=80" type="image/webp">
										<img src="${this.product.ImageUrl}?height=412&width=412&mode=crop&scale=both&quality=80" loading="${this.eagerLoadImages ? 'eager' : 'lazy'}" fetchpriority="${this.eagerLoadImages ? 'high' : nothing}" alt="${this.product.ImageAlt}" width="412" height="412">
									</picture>
									${this.product.HasHoverImage ?
									html`
									<picture class="c-image__hover-image">
										<source srcset="${this.product.HoverImageUrl}?height=412&width=412&mode=crop&scale=both&format=webp&quality=80" type="image/webp">
										<img src="${this.product.HoverImageUrl}?height=412&width=412&mode=crop&scale=both&quality=80" tabindex="-1" alt="" data-test="hover-image" loading="lazy" width="412" height="412">
									</picture>`
									: null }
								</div>
								`}
							</a>
							${showPreviews ?
							html`
							<div class="c-product__variants__container">
								<div class="c-product__variants">
									<ul class="c-product__variants__list ${this._allowMoreTextToBreakOnToNewLine ? "c-product__variants__list--multiline" : ""}">
									${this.product.Previews && this.product.Previews.map((preview) =>
										html`<li class="c-product__variants__item c-product__variants__item--swatch" data-test="preview-thumbnail" data-variant-name="${preview.DisplayName}">
											<a href="${preview.Url}" class="c-product__variants__link js-product-variant" data-image="${preview.HasDisplayImage ? `${preview.DisplayImage}?height=412&width=412&mode=crop&scale=both&quality=80` : nothing}" data-test="thumbnail-${preview.Sku}" data-product-guid="${preview.ProductGuid || nothing}">
												<div class="c-image c-image--square c-image--lazy">
													<picture>
														<source srcset="${preview.PreviewThumbnail}?height=24&width=24&mode=crop&scale=both&format=webp&quality=80" type="image/webp">
														<img src="${preview.PreviewThumbnail}?height=24&width=24&mode=crop&scale=both&quality=80" loading="${this.eagerLoadImages ? 'eager' : 'lazy'}" alt="${preview.DisplayName}" width="36" height="36" data-test="preview-thumbnail-image">
													</picture>
												</div>
											</a>
										</li>`
									)}
									${this._numberHiddenSwatches ?
										html`
										<li class="c-product__variants__item c-product__variants__item--more c-product__variants__item--more--number" data-test="variant-more-swatches-text">
											<a href="${productURL}" class="c-product__variants__link js-product-link" data-instant @click="${this.productLinkOnClick}">+<span class="c-product__variants__link__text">${this._numberHiddenSwatches}</span></a>
										</li>
										`
									: null}
									${this.product.ShowVariantOptionsText ?
										html`
										<li class="c-product__variants__item c-product__variants__item--more ${this.product.ShowVariantOptionsText ? "c-product__variants__item--always" : ''} js-variant-options-text" data-test="variant-plural-text">
											<a href="${productURL}" class="c-product__variants__link js-product-link" data-instant @click="${this.productLinkOnClick}">+ <span class="c-product__variants__link__text">${this.product.VariantOptionsText}</span></a>
										</li>
										`
									: null}
									</ul>
								</div>
							</div>`
						: null}
						</div>

						<div class="c-product__content ${(!showPreviews && (!this.hideVariants || this.hideSiblings)) ? 'c-product__content--no-previews' : ''}">

							<p class="c-product__title">
								<a class="c-product__title__link js-product-link" href="${productURL}" data-test="${this.testProductDisplayName ?? "product-name"}" data-instant @click="${this.productLinkOnClick}"><span class="c-product__title__link__text">${this.product.DisplayName}</span></a>
							</p>

							<div class="c-product__price-wishlist-group">

								<div class="c-product__price">
									<product-price
									hideRrp="${this.product.HideRrp || nothing}"
									showSaleWasPrice="${this.product.ShowSaleWasPrice || nothing}"
									IsTradeCustomer="${this.product.IsTradeCustomer || nothing}"
									rrp="${this.product.RRP.Formatted}"
									retailPrice="${this.product.RetailPrice.Formatted}"
									wasPrice="${this.product.OriginalPrice.Formatted}"
									hasVariants="${this.product.HasVariants || nothing}"
									price="${this.product.Price.Formatted}"
									/>
								</div>

								${this.comparingMode ?
									html`
								<div class="c-product__comparison-toggle js-ignore-product-card-click" data-test="product-comparison-toggle-container">
									<label class="c-toggle js-ignore-product-card-click">
										<span class="c-toggle__label">
											Compare
										</span>
										<input
											type="checkbox"
											class="c-toggle__input"
											.checked="${this.isComparing}"
											@change="${this.addToComparison}"
											data-test="product-comparison-toggle"
										/>
										<span class="c-toggle__slider"></span>
									</label>
								</div>
								`
									:
									html`${this.getSlot('wishlist-button') ? this.getSlot('wishlist-button') : html`<wishlist-button productName="${this.product.Name}" />` }`
								}

							</div>

							<div class="c-product__footer ${!this.product.HasReviews ? 'c-product__footer--no-reviews' : ''}">
								${this.product.HasReviews ?
								html`<div class="c-product__rating">
									<product-rating reviewPercentage="${this.product.ReviewPercentage}" reviewCount="${this.product.ReviewCount}" />
								</div>`
								: null}
								${this.product.HasOverlays ?
								html`
									<div class="c-product__overlay ${isCarouselMode ? 'c-product__overlay--mobile' : ''} c-merch-overlay__group" data-test="merchandise-overlay">
										${this.product.Overlays.map((overlay) => {
												return html`
												<merch-overlay
													shortText="${overlay.ShortText}"
													backgroundColor="${overlay.Theme.BackgroundColor}"
													textColor="${overlay.Theme.TextColor}"
												></merch-overlay>
											`;
												})}
									</div>`
								: null}
								<div class="c-product__delivery">
									<p class="c-delivery c-delivery--${this.product.Stock.CssClass}" data-test="${this.testProductDeliveryEstimate}">${unsafeHTML(this.product.DeliveryEstimate)}</p>
								</div>
								${this.getSlot('footer')}
								${this.showAddButton ?
									html`
										${this.product.HasVariants ?
											html`
											<div class="c-product__action">
												<div class="c-add-product" id="add-product-upsell-product-${this.product.Name}">
													<product-viewer-open-button .buttonOnClick="${this.productLinkOnClick}" productId="${this.product.Name}" productDisplayName="${this.product.DisplayName}" showMessage text="Choose Options" test="product-viewer-choose-options"></product-viewer-open-button>
												</div>
											</div>
											`
										:
									html`
									<div class="c-product__action">
										<product-add
										viewItemEventInfo='${this.product.ViewItemEventInfoJson}'
										name="${this.product.Name}"
										sku="${this.product.Name}"
										displayName="${this.product.DisplayName}"
										guid="${this.product.Guid}"
										price="${this.product.Price.Price}"
										loggerSource=${this.addButtonLoggerSource}></product-add>
									</div>`
										}
									`
								: null}
								${this.showAddButtonOnBasket ?
										html`
										${this.product.HasVariants ?
										html`
											<div class="c-product__action">
													<product-viewer-open-button .buttonOnClick="${this.productLinkOnClick}" productId="${this.product.Name}" productDisplayName="${this.product.DisplayName}" text="Choose Options" test="product-viewer-choose-options"></product-viewer-open-button>
											</div>
											`
										:
										html`
										<div class="c-product__action">
											<button type="button" class="c-button c-button--full c-button--secondary js-product-link" @click="${this.addButtonOnBasketClick}" disabled="${this.isLoading || nothing}" data-test="${this.addButtonOnBasketTest || nothing}">
												<span aria-hidden="true">+</span> Add <span class="u-visuallyhidden">${this.product.DisplayName}</span> to basket
												${this.isLoading ?
														html`
															<span class="c-loader c-loader--inline"></span>
														`
												: null}
											</button>
										</div>`
									}
									`
								: null}
								${!this.showAddButton && !this.showAddButtonOnBasket ?
									html`<product-viewer-open-button-message productId = "${this.product.Name}"></product-viewer-open-button-message>`
								: nothing}
							</div>
						</div>
					</div>
				</article>
		`;
	}

}
